import { Checkbox, DataSource, Label, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutMarketExprtOutputFiltersPanel extends Layout {
    checkboxCommodityCode: Checkbox;
    checkboxExcludeCarrierCode: Checkbox;
    checkboxExcludeCustomerCode: Checkbox;
    checkboxExcludeLocationCode: Checkbox;
    checkboxExcludeOrderType: Checkbox;
    checkboxExcludeRevenueCode: Checkbox;
    labelOutputFilters: Label;
    panel1: Panel;
    panel2: Panel;
    panel4: Panel;
    sourceMarketrateExprt: DataSource;
    textboxCarrier: Textbox;
    textboxCommodityFilter: Textbox;
    textboxCustomerCodeList: Textbox;
    textboxLocationCode: Textbox;
    textboxOrderTypeI: Textbox;
    textboxRevenueCodeFilter: Textbox;
}
